import React from 'react';
import { useTranslation } from 'react-i18next';
import { PaymentMethod } from '../../services/types/apitypes';
import PaymentItem from './PaymentItem';
import { AdditionalPaymentMethod } from './PaymentsList';

type PaymentMethodSelectorProps = {
  payment: PaymentMethod | AdditionalPaymentMethod;
  click: () => void;
};

// The selected payment method on a checkout screen; tapping it opens the
// payment method list.
export default function PaymentMethodSelector({
  payment,
  click,
}: PaymentMethodSelectorProps) {
  const [t] = useTranslation('global');

  return (
    <>
      <h1 className="h1 h1plus pb-1">{t('payments.selectmethod')}</h1>
      {typeof payment === 'string' ? (
        <PaymentItem click={click} otherPaymentType={payment} />
      ) : (
        <PaymentItem payment={payment} click={click} />
      )}
    </>
  );
}
